import HeroDefaultStyle from '@/styles/components/careers/hero-section/_index.module.scss';
import { EdiText, useState, EditImage } from '@/imports-files/pages/career/customize-career-page';

export function TestSection(props)
{
  const [editText, setEdittext] = useState(false);
  const [value, setTextValue] = useState("hello");
  const [isEditing, setIsEditing] = useState(false)

  function updateLabelText(val, setTextValue, setIsEditing){
    if(val.trim().length > 0)
    {
      setTextValue(val);
      setIsEditing(false)
    }
  }

  function styleHash(){
    return {
      color: "#abcabc",
      fontFamily: 'Parabole',
      fontSize: "1rem",
      fontWeight: 'bold',
      fontStyle: 'italic',
      textDecoration: 'underline'
    }
  }

  function buttonStyleHash(){
    return {
      backgroundColor: "#abcabc",
      color: "#000000",
      borderRadius: 2,
      fontSize: 15,
      fontFamily: 'Gellix',
      fontWeight: 'bold',
      fontStyle: 'italic',
      textDecoration: 'underline'
    }
  }

  return(
    <div className='test-div'>
      <h3>FooterText</h3>
      <button className='test-button' type={'button'} style={buttonStyleHash()}>Button 1</button>
    </div>
  )
}